<template>
    <div class="container-fluid">
        <nav v-cloak aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li
                    v-for="(breadcrumb, index) in breadcrumbs"
                    :key="index"
                    :class="{active: index === breadcrumbs.length - 1}"
                    class="breadcrumb-item"
                >
                    <a :href="breadcrumb.link">{{ breadcrumb.label }}</a>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        breadcrumbs: {
            type: Array,
            default: []
        }
    }
}
</script>
